// @core/api/endpoints/affiliate/create_referral_link.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  CreateReferralLinkRequest,
  ReferralLinkResponse,
} from '../../../types/affiliate';

const BASE_PATH = '/affiliate';

/**
 * Create referral link
 * Creates a new referral link with the provided data. Returns the created resource.
 */
export async function CreateReferralLink(
  data: CreateReferralLinkRequest,
  options?: RequestOptions
): Promise<ReferralLinkResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/referral-links`;
  const requestOptions = options;
  return client.post<ReferralLinkResponse>(requestPath, data, requestOptions);
}
